import { createStore, applyMiddleware, compose  } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';
import Storage from './utils/Storage';

const persistConfig = {
  key: 'root',
  storage: Storage()
}

const persistedReducer = persistReducer(persistConfig, rootReducer);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore() {
  let store = createStore(
    persistedReducer,
    composeEnhancers(
      applyMiddleware(thunk)
    )
  );
  
  let persistor = persistStore(store);

  return { store, persistor }
}


// WEBPACK FOOTER //
// ./src/store.js